// @ts-strict-ignore
import {Section, SectionItem} from 'common/components/items-menu/types';
import {SelectionState} from 'common/components/items-menu/constants';
import {TableColumn} from 'common/components/table/types';
import {Translatable} from 'common/i18n';

export interface ButtonActionOption {
  eventName: string;
  label: string;
  disabled?: boolean;
  type?: string;
  icon?: string;
  tooltip?: Translatable;
  disabledTooltip?: Translatable;
  toolTipMaxWidthStyle?: string;
  href?: string;
  target?: string;
}

export interface SelectActionOption {
  eventName: string;
  label: string;
  sections: Section[];
  icon?: string;
  menuWidth?: number;
  menuHeight?: number;
}

export type ActionOption = ButtonActionOption | SelectActionOption;

export enum FilterType {
  /** filter that displays one kind of filter */
  Simple = `simple`,
  /** filter that displays multiple filter types in one */
  Complex = `complex`,
}

export interface FilterSimpleConfig {
  filterType?: FilterType.Simple;
  name: string;
  /**
   * The default initial value (if `isSelected` isn't specified on any item). When the filter is reset, this
   * value will be used. Filter items need to have value key to use this - i.e. item objects should be of the
   * format `{value: "item-id", label: "Item"}` */
  defaultFilterValue?: any;
  /** @deprecated use defaultFilterValue instead */
  defaultFilterLabel?: string;
  // does the default filter actually filter results (rather than returning all results)
  defaultFilterIsNotAll?: boolean;
  label?: string;

  applyButton?: string;
  /** can select multiple labels for multi-filtering */
  multiple?: boolean;
  sections: Section[];
  menuWidth?: number;
  theme?: string; // button theme
}

export interface FilterComplexConfig {
  filterType?: FilterType.Complex;
  name: string;
  defaultFilterValue?: string;
  /** @deprecated use defaultFilterValue instead */
  defaultFilterLabel?: string;
  label?: string;

  sections: Section[];
  /** can select multiple labels for multi-filtering */
  multiple?: boolean;
  menuWidth?: number;
}

export type FilterSelectConfig = FilterSimpleConfig | FilterComplexConfig;

export type GetFilterSortedMenuSections = (name, section: Section[]) => Section[];

export type ClickActionEvent = CustomEvent<{
  fromIndex: number;
  toIndex: number;
  column: TableColumn;
  columns: TableColumn[];
}>;

export type FilterMenuChangeEvent = CustomEvent<{
  name: string;
  isOpen: boolean;
}>;

export type FilterSelectAllEvent = CustomEvent<{
  name: string;
  selectionState: SelectionState;
  previousSelected: Section[];
  selected: Section[];
}>;

export type UpdateInputEvent = CustomEvent<{
  value: string;
}>;

export type ApplyFilterEvent = CustomEvent<{selected?: SectionItem[]; name: string}>;
